<template>
    <div id="CardLayout">
        <div class="cards-relatorios">
            <div class="card-icon">
                <i class="fa fa-bar-chart"></i>
            </div>
            <div class="card">
                <div class="card-body">
                    <h6>
                        <slot name="type"></slot>
                    </h6>
                    <h2>
                        <slot name="title"></slot>
                    </h2>
                </div>
                <div class="card-footer">
                    <slot name="button"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

    #CardLayout {
        height: 100%;

        .cards-relatorios {
            text-align: center;
            height: 100%;

            .card-icon {
                text-align: center;
                margin: 0;
                position: relative;
                z-index: 99;
                margin-bottom: -35px;

                span {
                    width: 50px;
                    background-color: red;
                    height: 50px;
                }

                [class*="fa fa-"] {
                    background-color: white;
                    border-radius: 50px;
                    color: #1c2d5a;
                    display: inline-block;
                    height: 70px;
                    line-height: 70px;
                    margin: auto 3px;
                    width: 70px;
                    font-size: 25px;
                    text-align: center;
                    -webkit-box-shadow: 0 4px 9.6px 0.4px #d2d1d13b;
                    box-shadow: 0 4px 9.6px 0.4px #d2d1d13b;
                }

                [class*="fa fa-file-text"]:hover, [class*="fa fa-bar-chart"]:hover {
                    background-color: #444;
                    color: white;
                }
            }
            
            .card {
                margin: 0;
                width: 100%;
                height: 100%;
                box-shadow: none;
                -webkit-box-shadow: 0 4px 9.6px 0.4px #d2d1d1;
                box-shadow: 0 4px 9.6px 0.4px #d2d1d1;
            }

            .card .card-body {
                min-height: 12rem;
                height: 100%;
                background-color: #1c2d5a;
                color: white;
                padding: 3rem 2rem 1rem;
                border-radius: 10px 10px 0px 0px;

                h6 {
                    font-size: 14px;
                }

                h2 {
                    padding: 0px;
                    font-size: 22px;
                    font-weight: 600;
                }

            }

            .card .card-footer {

                width: 100%;
                padding: 0px;
                border: none;

                button {
                    width: 100%;
                    color: #1c2d5a;
                    background: white;
                    box-shadow: none;
                    border-radius: 0px 0px 10px 10px;
                    font-weight: 600;
                }

                button:hover {
                    background-color: #444;
                    color: white;
                }

            }

        }
    }

</style>